import { render } from "./ButtonCorporateRequests.vue?vue&type=template&id=5c0f6746&scoped=true"
import script from "./ButtonCorporateRequests.vue?vue&type=script&lang=js"
export * from "./ButtonCorporateRequests.vue?vue&type=script&lang=js"

import "./ButtonCorporateRequests.vue?vue&type=style&index=0&id=5c0f6746&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0f6746"]])

export default __exports__